import type { ParsedUrlQuery } from "querystring";

/**
 * Client-only deeplink keys that must not be forwarded to the order-details API.
 */
export const stripClientOnlyDeeplinkParams = <
  T extends Record<string, unknown> | ParsedUrlQuery
>(
  params?: T | null
): T | undefined => {
  if (!params) {
    return undefined;
  }
  const { action: _action, ...rest } = params as Record<string, unknown>;
  return rest as T;
};
